import { useCallback, useEffect, useState } from "react";
import doctorService from "../doctorService";
import { IDoctor } from "../interface/doctor.interface";

/**
 * A doctor's public profile. Refetches when the slug or language changes, and drops the previous
 * doctor straight away so a slow response can never show one doctor under another's URL.
 */
const useGetDoctorBySlug = (slug: string, lang?: string) => {
  const [data, setData] = useState<IDoctor>();
  const [isLoading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<unknown>();
  const [attempt, setAttempt] = useState<number>(0);

  useEffect(() => {
    let ignore = false;

    setData(undefined);
    setError(undefined);
    setLoading(true);

    (async () => {
      try {
        const response = await doctorService.getBySlug(slug, lang);

        if (!ignore) {
          setData(response.data);
        }
      } catch (error) {
        if (!ignore) {
          setError(error);
        }
      } finally {
        if (!ignore) {
          setLoading(false);
        }
      }
    })();

    return () => {
      ignore = true;
    };
  }, [slug, lang, attempt]);

  const refetch = useCallback(() => setAttempt((value) => value + 1), []);

  return { data, error, isLoading, refetch };
};

export default useGetDoctorBySlug;
